import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import BookingCTA from "@/components/home/BookingCTA";
import LegacyContent from "@/components/site/LegacyContent";
import { SITE } from "@/data/site";

export default function Legacy() {
  return (
    <PageShell testId="legacy-page">
      <PageHero
        overline="Our Legacy & Vision"
        title={["Rooted in the", "Western Ghats"]}
        subtitle="Built with the soul of Malnad — a sanctuary shaped by mist, forest and quiet time."
        image={SITE.aboutImage1}
      />

      <LegacyContent testId="legacy-page-content" />

      <BookingCTA />
    </PageShell>
  );
}
